import type { EhsrClause } from './types'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type EhsrBadgeProps = {
  clauseId: string
  clause?: EhsrClause
}

export function EhsrBadge({ clauseId, clause }: EhsrBadgeProps) {
  const badgeLabel = clause?.selectedLabel ?? clauseId
  const tooltipLabel = clause?.label ?? clauseId

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant='secondary' className='max-w-full text-xs'>
          <span className='min-w-0 truncate'>{badgeLabel}</span>
        </Badge>
      </TooltipTrigger>
      <TooltipContent side='top' className='max-w-sm'>
        {tooltipLabel}
      </TooltipContent>
    </Tooltip>
  )
}
